const TemperatureControl = () => {
    return (
      <div>
  
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
              Temperature Controlled
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              From strict delivery schedules to consistently maintained temperatures throughout the cargo's journey, 
              our cold chain solutions cater to the growing needs of the industries nationwide. With end-to-end visibility 
              and transparency for customers of cold cargo and much more than simple storage and transportation, 
              TCS provides integrated logistics solutions.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center lg:mt-[0rem] mt-[1rem]">
              <img src="/overland/Temperature-Control-Inside.jpg" alt="" className="max-w-[100%] rounded-md"/>
          </div>
          </div>
      
      </div>
    </div>
    );
  };
  
  export default TemperatureControl;
  